export const SUBMIT = 'review/SUBMIT';



// WEBPACK FOOTER //
// ./src/review/reviewActions.js